import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.5 13.5 5.3 9.4a4 4 0 1 1 6.4 0z" }, null, -1 /* CACHED */),
    _createElementVNode("rect", {
      width: "9",
      height: "6.5",
      x: "17",
      y: "13",
      rx: "1.5"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M8.5 13.5V24H17m-8.5-7.75H17M17 24h1.5l1.5-2.5 2 5 1.5-2.5H26" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }